import {
  AiOutlineUser,
  AiOutlineSetting
} from "react-icons/ai";
import { GiDogBowl } from "react-icons/gi";
import { HiOutlineDeviceMobile, HiOutlinePresentationChartLine } from "react-icons/hi";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { FaDog, FaHandHoldingDollar } from "react-icons/fa6";
import { IoMdNotificationsOutline } from "react-icons/io";
import { MdFeedback } from "react-icons/md";
import { VscGraph, VscFeedback } from "react-icons/vsc";
const data = [
  {
    id: "analytics",
    icon: <VscGraph />,
    label: "Analytics",
  },

  {
    id: "users",
    icon: <AiOutlineUser />,
    label: "Users",
  },
  {
    id: "role-and-access",
    icon: <HiOutlineUserGroup />,
    label: "Roll & Access",
  },
  {
    id: "pets",
    icon: <FaDog />,
    label: "Pets",
  },
  {
    id: "benchmark",
    icon: <HiOutlinePresentationChartLine />,
    label: "Benchmark",
  },
  {
    id: "device",
    icon: <HiOutlineDeviceMobile />,
    label: "Pet's Device",
  },
  {
    id: "feeder",
    icon: <GiDogBowl />,
    label: "Feeder",
  },
  {
    id: "plan",
    icon: <FaHandHoldingDollar />,
    label: "Plan",
  },
  {
    id: "feedback",
    icon: <VscFeedback />,
    label: "Feedback",
  },
  {
    id: "mode-feedback",
    icon: <MdFeedback />,
    label: "Mode Feedback",
  },
  {
    id: "notification",
    icon: <IoMdNotificationsOutline />,
    label: "Notification",
  },
  {
    id: "config",
    icon: <AiOutlineSetting />,
    label: "App Config",
  },



];
export default data;
